import React from 'react';
import './pages.css'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import "@fontsource/amiri"
import { tsParticles } from "tsparticles-engine";
import { loadPolygonPath } from "tsparticles-path-polygon";

function Experience() {
  (async () => {
    await loadPolygonPath(tsParticles);
  
    await tsParticles.load({
      particles: {
        color: {
          value: "#FF0000",
          animation: {
            enable: true,
            speed: 10
          }
        },
        move: {
          attract: {
            enable: false,
            distance: 100,
            rotate: {
              x: 2000,
              y: 2000
            }
          },
          direction: "none",
          enable: true,
          outModes: {
            default: "destroy"
          },
          path: {
            clamp: false,
            enable: true,
            delay: {
              value: 0
            },
            generator: "polygonPathGenerator",
            options: {
              sides: 6,
              turnSteps: 30,
              angle: 30
            }
          },
          random: false,
          speed: 2,
          straight: false,
          trail: {
            fillColor: "#000",
            length: 20,
            enable: true
          }
        },
        number: {
          density: {
            enable: true,
            area: 800
          },
          value: 0
        },
        opacity: {
          value: 1
        },
        shape: {
          type: "circle"
        },
        size: {
          value: 2
        }
      },
      background: {
        color: "#000"
      },
      fullScreen: {
        zIndex: -1
      },
      emitters: {
        direction: "none",
        rate: {
          quantity: 1,
          delay: 1
        },
        size: {
          width: 0,
          height: 0
        },
        position: {
          x: 50,
          y: 50
        }
      }
    });
  })();


    return(
        <div class='Experience'>
            <Box className='header'>
                <Typography variant='h3' sx={{fontFamily: 'Amiri'}}>Experience</Typography>
            </Box>
            <div className='exp'>
                <Card className='card'>
                    <img src={require('./images/toyota.png')} height='150' width='150' alt='Toyota'/>
                    <CardContent className='cardText'>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 22, color: '#173A5E', fontWeight: 'bold'}}>
                            Toyota Motor North America
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 18, color: '#173A5E', fontStyle: 'italic'}}>
                            Software Developer
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', fontStyle: 'italic', borderBottom:1}}>
                            August 2022 - December 2022
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', pt: 1}}>
                            During my Senior year at UT Dallas, Toyota Motor North America hosted a Computer Science project. Over the course of the semester, a small team and I created a surveying tool for managers to gauge employee satisfaction. 
                            <br/><br/>
                            Through weekly interfacing with Toyota North America, I learned the importance of understanding a customer's software requirements and design preferences.
                            <br/><br/>
                            For this project we created a web application that used a combination of React, Typescript, and CSS. We created unique React components like an interactive calendar and interactive charts to display data in an appealing fashion.
                            <br/><br/>
                        </Typography>
                    </CardContent>
                </Card>
                <Card className='card'>
                    <img src={require('./images/quai.png')} height='150' width='150' alt='Quai'/>
                    <CardContent className='cardText'>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 22, color: '#173A5E', fontWeight: 'bold'}}>
                            Quai
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 18, color: '#173A5E', fontStyle: 'italic'}}>
                            Software Developer Intern
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', fontStyle: 'italic', borderBottom:1}}>
                            January 2022 - August 2022
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', pt: 1}}>
                            I worked as a Software Developer Intern at Quai, a startup company creating cutting-edge blockchain technology. I gained insight into the software development life cycle, the daily challenges and responsibilities of a Software Developer, and proper management of a project using a VCS. 
                            <br/><br/>
                            Using Go, I worked on a large variety of projects. The most memorable was a blockchain visualizer that could graphically display the current state of the blockchain.
                            An important lesson I learned with this project was the significance of making tools dynamic and interactable. With this project I also created a custom CLI that allows a user to interact with the blockchain visualizer.
                            <br/><br/>
                            By working closely with the CEO of the company, senior developers and other executive board members, I learned about important decision making and how to properly manage a project.
                            <br/><br/>
                            <u><a href='https://qu.ai/' target='_blank' rel='noreferrer'>Website</a></u>
                            <br/>
                            <u><a href='https://github.com/dominant-strategies/go-quai' target='_blank' rel='noreferrer'>Github</a></u>

                        </Typography>
                    </CardContent>
                </Card>
                <Card className='card'>
                    <img src={require('./images/amazon.jpg')} height='150' width='150' alt='Amazon' />
                    <CardContent className='cardText'>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 22, color: '#173A5E', fontWeight: 'bold'}}>
                            Amazon
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 18, color: '#173A5E', fontStyle: 'italic'}}>
                            Stower
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', fontStyle: 'italic', borderBottom:1}}>
                            July 2020 - August 2020
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', pt: 1}}>
                            At Amazon I worked as a stower in the HOU3 facility, for 10 hour night shifts with a sustained high rate of efficiency.
                            <br/><br/>
                            In order to work effectively at this facility, I was certified in vehicle operations and warehouse safety protocols, as well as mastered the layout and organization of the facility.
                            <br/><br/>
                            Working here taught me the importance of time management and how to work in a fast paced environment. It also gave me an interesting insight to the logistics of an extremely large scale company.
                            
                        </Typography>
                    </CardContent>
                </Card>
                <Card className='card'>
                    <img src={require('./images/randalls.jpeg')} height='150' width='150' alt='Randalls'/>
                    <CardContent className='cardText'>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 22, color: '#173A5E', fontWeight: 'bold'}}>
                            Randalls
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 18, color: '#173A5E', fontStyle: 'italic'}}>
                            Stocker
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', fontStyle: 'italic', borderBottom:1}}>
                            June 2016 - February 2017
                        </Typography>
                        <Typography sx={{fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', pt: 1}}>
                            Randalls was the first experience I had with working in a retail environment. I worked part-time after school and on the weekends. Here I learned the importance of customer service and how to work in a team environment.
                            <br/><br/>
                            I started at Randalls as a courtesy clerk and was promoted to cashier through good performance.
                        </Typography>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default Experience